<template>
    <div class="pa-6 d-flex flex-column gap-6" data-testid="workflow-edit-details__root">
        <!-- Breadcrumbs for RU Data Section view -->
        <Breadcrumbs
            v-if="showCycleBreadcrumb"
            :glCodeText="breadcrumbCycleLabel"
            :glCodeInfo="cycleBreadcrumbText"
            :activeCommentary="{}"
            :getStatusLabel="getStatusLabel"
            :isRefreshing="isReportingUnitdataloading"
            :reportingType="reportingType || 'pl'"
            @back="goBack"
            @refresh="handleRefreshData"
            data-testid="variance-analysis-base__breadcrumbs"
            :showRefresh="false"
        />
        <template v-if="isReportingUnitdataloading">
            <div class="d-flex gap-4">
                <v-skeleton-loader type="chip" width="200" class="mr-2"></v-skeleton-loader>
                <div class="vertical"></div>
                <v-skeleton-loader type="chip" width="200" class="mr-2"></v-skeleton-loader>
                <div class="vertical"></div>
                <v-skeleton-loader type="chip" width="200"></v-skeleton-loader>
            </div>
            <v-card outlined class="pa-3">
                <v-skeleton-loader type="table-heading" class="mb-4"></v-skeleton-loader>
                <div class="d-flex gap-4">
                    <v-skeleton-loader type="image" height="400" style="width: 50%"></v-skeleton-loader>
                    <v-skeleton-loader type="image" height="400" style="width: 50%"></v-skeleton-loader>
                </div>
            </v-card>
        </template>
        <template v-else>
            <div class="d-flex gap-4">
                <v-chip label class="chip-choose" data-testid="reporting-unit-dialog__network-chip">
                <span class="categorystype">{{ $nova.labelsName('my_reporting_units_page', 'division_label', 'Network') }} - {{ detail.network_detail?.name }}</span>
                </v-chip>
                <div class="vertical"></div>
                <v-chip label class="chip-choose" data-testid="reporting-unit-dialog__region-chip">
                <span class="categorystype">{{ $nova.labelsName('my_reporting_units_page', 'region_label', 'Region') }} - {{ detail.region_detail?.name }}</span>
                </v-chip>
                <div class="vertical"></div>
                <v-chip label class="chip-choose" data-testid="reporting-unit-dialog__country-chip">
                <span class="categorystype">{{ $nova.labelsName('my_reporting_units_page', 'country_label', 'Country') }} - {{ detail.country_detail?.name }}</span>
                </v-chip>
            </div>
            <v-card class="pa-3" outlined data-testid="workflow-edit-details__card">
                <v-tabs
                    v-model="tab"
                    background-color="transparent"
                    class="workflow-edit-details__tabs"
                    data-testid="workflow-edit-details__tabs"
                >
                    <v-tab
                        key="details"
                        data-testid="workflow-edit-details__tab--details"
                    >
                        Workflow
                    </v-tab>
                    <v-tab
                        key="history"
                        data-testid="workflow-edit-details__tab--history"
                    >
                        User List
                    </v-tab>
                </v-tabs>
                <v-divider></v-divider>
                <v-tabs-items v-model="tab" data-testid="workflow-edit-details__tabs-items">
                    <v-tab-item
                        key="details"
                        data-testid="workflow-edit-details__tab-item--details"
                    >
                        <WorkflowConfigTab class="pt-3" :detail="detail" @refresh="handleRefreshData" />
                    </v-tab-item>
                    <v-tab-item
                        key="history"
                        data-testid="workflow-edit-details__tab-item--history"
                    >
                        <UserListTab class="pt-3" :detail="detail" />
                    </v-tab-item>
                </v-tabs-items>
            </v-card>
        </template>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Breadcrumbs from '../../../components/Breadcrumbs.vue';
import WorkflowConfigTab from './WorkflowConfigTab.vue';
import UserListTab from '../../../components/UserListTab.vue';

export default {
    name: 'WorkflowEditDetails',
    components: {
        Breadcrumbs,
        WorkflowConfigTab,
        UserListTab
    },
    data() {
        return {
            showCycleBreadcrumb: true,
            breadcrumbCycleLabel: 'Workflow Configuration',
            cycleBreadcrumbText: '',
            isReportingUnitdataloading: false,
            reportingType: 'pl',
            tab: null,
        };
    },
    computed: {
        ...mapGetters('varianceanalysis/reportingUnit', ['getRUDetail']),
        detail() {
            return this.getRUDetail || {};
        }
    },
    watch: {
        detail: {
            handler(val) {
                if (val && val.code) {
                    this.cycleBreadcrumbText = `${val.code} - ${val.name}`;
                }
            },
            immediate: true
        }
    },
    created() {
        this.fetchData();
    },
    methods: {
        ...mapActions('varianceanalysis/reportingUnit', ['fetchRUDetail']),
        
        async fetchData(forceRefresh = false) {
            const id = this.$route.params.id;
            if (!id) return;

            this.isReportingUnitdataloading = true;
            try {
                await this.fetchRUDetail({
                    filter: { reportingunit: [id] },
                    axiosInstance: this.axios,
                    forceRefresh: forceRefresh === true
                });
            } catch (error) {
                console.error("Failed to fetch RU details", error);
            } finally {
                this.isReportingUnitdataloading = false;
            }
        },

        getStatusLabel(key, fallback) {
            return fallback || key;
        },
        goBack() {
            // Clear both caches so Workflow.vue fetches fresh data on remount
            this.$store.commit('varianceanalysis/reportingUnit/CLEAR_RU_CACHES');
            // Navigate immediately
            this.$nova.gotoLink({
                path: '/varianceanalysis/workflow'
            });
        },
        handleRefreshData() {
            this.fetchData(true);
        }
    }
};
</script>
<style scoped>
.workflow-edit-details__tabs .v-tab {
    text-transform: none;
    font-weight: 600;
    font-size: 16px;
    color: var(--color-primary-base) !important;
    padding: var(--space-2xs) var(--space-md);
}
::v-deep .workflow-edit-details__tabs .v-tabs-bar {
    height: 34px !important ;
}
</style>